import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalCreateOrderGuideFromMenuItemsDocument = gql`
  mutation SalesPortalCreateOrderGuideFromMenuItems(
    $items: [MenuItemInput!]!
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    createOrderGuideFromGeneratedMenuItems(
      items: $items
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      order_guide_collection_uuid
      order_guide_partition_uuid
    }
  }
`;
export type SalesPortalCreateOrderGuideFromMenuItemsMutationFn =
  Apollo.MutationFunction<
    Types.SalesPortalCreateOrderGuideFromMenuItemsMutation,
    Types.SalesPortalCreateOrderGuideFromMenuItemsMutationVariables
  >;
export function useSalesPortalCreateOrderGuideFromMenuItemsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalCreateOrderGuideFromMenuItemsMutation,
    Types.SalesPortalCreateOrderGuideFromMenuItemsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalCreateOrderGuideFromMenuItemsMutation,
    Types.SalesPortalCreateOrderGuideFromMenuItemsMutationVariables
  >(SalesPortalCreateOrderGuideFromMenuItemsDocument, options);
}
export type SalesPortalCreateOrderGuideFromMenuItemsMutationHookResult =
  ReturnType<typeof useSalesPortalCreateOrderGuideFromMenuItemsMutation>;
export type SalesPortalCreateOrderGuideFromMenuItemsMutationResult =
  Apollo.MutationResult<Types.SalesPortalCreateOrderGuideFromMenuItemsMutation>;
export type SalesPortalCreateOrderGuideFromMenuItemsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalCreateOrderGuideFromMenuItemsMutation,
    Types.SalesPortalCreateOrderGuideFromMenuItemsMutationVariables
  >;
